import { render, staticRenderFns } from "./FbOrderList.vue?vue&type=template&id=1b902e86&"
import script from "./FbOrderList.vue?vue&type=script&lang=js&"
export * from "./FbOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports